var initialPosition = 0;

//Funcion extendida animatecss
$.fn.extend({
	animateCss: function(animationName, callback) {
		var animationEnd = (function(el) {
			var animations = {
				animation: 'animationend',
				OAnimation: 'oAnimationEnd',
				MozAnimation: 'mozAnimationEnd',
				WebkitAnimation: 'webkitAnimationEnd',
			};

			for (var t in animations) {
				if (el.style[t] !== undefined) {
					return animations[t];
				}
			}
		})(document.createElement('div'));

		$(this).addClass('animated ' + animationName).one(animationEnd, function() {
			if(typeof callback === 'function'){
				callback();
			}
		});

		return this;
	}
});

$(document).ready(function () {

    //Eliminar animaciones de todo el sitio
    $('.animar').removeClass('animar');

	//Aplicar delay a elementos
	$('.animar[data-delay]').each(function() {
		var the_delay = $(this).attr('data-delay');
		$(this).css({
			'-webkit-animation-delay': the_delay + 'ms',
			'-o-animation-delay': the_delay + 'ms',
			'animation-delay': the_delay + 'ms'
		});
	});

	//Tabs
	$(document).on('click', '.slb-custom-product-tabs-actions li', function(e){
		e.preventDefault();
		var item_tab = $(this);
		var other_tabs = item_tab.siblings('li');
		var item_content = item_tab.attr('data-tab');
		var other_content = item_tab.parents('.section-custom-product-tabs').find('.slb-custom-product-tab-content:not(#'+item_content+')');
		
		if(!item_tab.hasClass('active')){
			item_tab.addClass('active');
			$('#'+item_content).addClass('active');
			other_tabs.removeClass('active');
			other_content.removeClass('active');
		}
	});

	//Slider principal
    var slider_main_dots = false;
    if($('.slb-slider-main .slb-custom-slider-item').length > 1){
      slider_main_dots = true;
    }
	$('.slb-slider-main').slick({
		infinite: true,
		centerMode: false,
		adaptiveHeight: true, 
		arrows: false,
		dots: slider_main_dots,
		slidesToShow: 1,
		slidesToScroll: 1
	});

	//Slider colecciones
	$('.slb-slider-collections').slick({
		infinite: true,
		centerMode: false,
		adaptiveHeight: true, 
		arrows: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		//slidesPerRow: 1,
		rows: 2, 
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					rows: 1
				}
			}
		]
	});

	//Slider productos
	$('.slb-slider-products').slick({
		infinite: true,
		centerMode: false,
		adaptiveHeight: true, 
		arrows: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	//Slider reviews
	$('.slb-slider-reviews').slick({
		infinite: true,
		centerMode: false,
		adaptiveHeight: true, 
		arrows: true,
		slidesToShow: 2,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	if($('.slb-slider-recent').length){

		$(document).ajaxStop(function () {

			var total_items = $('.slb-slider-recent .custom-slider-products-item');

			if(total_items.length){

				//Ejecutar slick slider
				$('.slb-slider-recent').slick({
					infinite: true,
					centerMode: false,
					adaptiveHeight: true, 
					arrows: true,
					slidesToShow: 4,
					slidesToScroll: 1,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						}
					]
				});
				
			}else{
				
				//Eliminar seccion
				$('.section-custom-recent-products').remove();
				
			}
		});

	}

  //Ejecutar acciones de scroll
  scrollAction();
  
  //Mostrar home
  $('#slb-custom-preloading').fadeOut(300, function(){
	$(this).remove();
  });
  
});

$(window).scroll(function () {
	scrollAction();
});

document.addEventListener('touchend', function(){
	if(navigator.userAgent.match(/(iPod|iPhone|iPad)/)){
		scrollAction();
	}
});

function scrollAction(the_position) {
	if(the_position){
		var position = the_position;
	}else{
		var position = $(window).scrollTop();
	}
	var windowVp = $(window).height();
	var windowWp = $(window).width();

	//Animar bloques al llegar a su posicion
	$('.section').each(function(index, el) {
		var the_layout = $(this);
		var the_items = the_layout.find('.animar');
		var altoSeccion = the_layout.innerHeight();
		var inicioSeccion = the_layout.offset().top;
		var finSeccion = inicioSeccion + altoSeccion;
		if(windowWp >= 768){
			var margin_scroll = 200;
		}else{
			var margin_scroll = 100;
		}

		//Ejecutar solamente si hay elementos a animar
		if(the_layout.find('.animar').length || the_layout.find('.animado').length){
		
			//Detectar sentido scroll
			if(position > initialPosition){
				//Scroll hacia abajo por lo que se muestran las animaciones al estar visibles en la pantalla
				var position_view = position + (windowVp / 1) - 20;
			}else{
				//Scroll hacia arriba por lo que se ocultaran las animaciones hasta que no sean visibles
				var position_view = position + (windowVp / 1);
			}

			var elements = the_layout.find('[data-lazy="true"]');
			if(elements.length){
				if(navigator.userAgent.match(/(iPod|iPhone|iPad)/)){
					lazy_items.loadAll(); //Cargar todas las imagenes
				}
			}

			//Si el navegador es corrido en ios
			if(navigator.userAgent.match(/(iPod|iPhone|iPad)/)){
				//Animar elementos
				the_items.each(function() {
					var the_item = $(this);
					var the_animation = the_item.attr('data-animation');
					the_item.animateCss(the_animation, function(element){
						the_item.removeClass('animated ' + the_animation).removeClass('animar').addClass('animado');
					});
				});
			}else{
				//Verificar posicion
				if(position_view >= inicioSeccion && position <= finSeccion){
					//Si el navegador es safari
					if((navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1)){
						//Animar elementos
						the_items.each(function() {
							var the_item = $(this);
							var the_animation = the_item.attr('data-animation');
							the_item.animateCss(the_animation, function(element){
								the_item.removeClass('animated ' + the_animation).removeClass('animar').addClass('animado');
							});
						});
					}else{
						the_items.each(function(index, el) {
							var the_item = $(this);
							var altoElemento = the_item.innerHeight();
							var inicioElemento = the_item.offset().top;
							var finElemento = inicioElemento + altoElemento;
							var the_animation = the_item.attr('data-animation');

							if(the_item.css('position') === 'absolute' || the_item.css('position') === 'fixed'){
								if(the_item.hasClass('animar')){
									the_item.animateCss(the_animation, function(element){
										the_item.removeClass('animated ' + the_animation).removeClass('animar').addClass('animado');
									});
								}
							}else{
								//Animar contenido si la posicion es cercana al inicio de la seccion
								if(position_view >= inicioElemento && position < finElemento){
									//Animar contenido
									if(the_item.hasClass('animar')){
										the_item.animateCss(the_animation, function(element){
											the_item.removeClass('animated ' + the_animation).removeClass('animar').addClass('animado');
										});
									}
								}
							}
						});
					}
				}else{
					//Si el navegador es corrido en ios o es safari
					if(navigator.userAgent.match(/(iPod|iPhone|iPad)/) || (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1)){
						//Evitamos que desaparezcan
					}else{
						the_layout.find('.animado').removeClass('animado').addClass('animar');
					}
				}
			}

		}
	});

	//Guardar valor al parar scroll
	clearTimeout(scroll_stop);
	var scroll_stop = setTimeout(function() {
		initialPosition = position;
	}, 100);

}